import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";
import axiosInstance from "../../../AxiosInstance/axiosInstance";

export const createAdvertisement = createAsyncThunk(
  "Advertisement/createAdvertisement",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/v1/admin/advertisement/create-advertisement`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAdvertisement = createAsyncThunk(
  "Advertisement/getAdvertisement",
  async (
    {
      status = "all",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstance.get(
        `/v1/admin/advertisement/get-advertisement`,
        {
          params: {
            status: status || "all",
            search,
            page: Number(page),
            limit: Number(limit),
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            paginate: paginate === "true",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const deleteAdvertisement = createAsyncThunk(
  "Advertisement/deleteAdvertisement",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.delete(
        `/v1/admin/advertisement/delete-advertisement/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getSingleAdvertisement = createAsyncThunk(
  "Advertisement/getSingleAdvertisement",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/advertisement/get-singleadvertisement/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateAdvertisement = createAsyncThunk(
  "Advertisement/update",
  async ({ _id, formData }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `/v1/admin/advertisement/update-advertisement/${_id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
